<template>
<div>
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

  <v-data-table
    :headers="headers"
    :items="cast_super_master_list"
    class="elevation-1"
     :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Cast</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details>
          </v-text-field>
          <span style="width: 20px"></span>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Add Cast </v-btn>
            <v-btn class="mb-2 mr-2" rounded color="success" small tile @click="openFileSelector()">
              <v-icon class="mr-2" small>mdi-file-import</v-icon>import Caste
            </v-btn>
          </template>
           
          <v-card>
            <v-form v-model="valid">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.cast_super_master" 
                    persistent-hint
                    :hint="editedIndex==-1?'For example :: Maratha, Brahmin':'For example :: Maratha, Brahmin'"
                    label="Enter Cast"
                    :rules="[v => !!v || 'required']"
                    >
                    </v-text-field>
                  </v-col>
                   <!-- <v-col cols="12" sm="6" md="4" v-if='editedIndex != -1'>
                     <v-checkbox
                        dense
                        v-model="editedItem.isactive"
                        color="success"
                        label="Active"
                      ></v-checkbox>
                  </v-col>      -->
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field label="Enter Cast In Unicode" v-model="editedItem.unicode_cast_name"></v-text-field>
                  </v-col>
                </v-row>
               
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="primary darken-1"  @click="save" :disabled="!valid">Save</v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

      </v-toolbar>
   

    </template>

         <!-- <template v-slot:item.isactive="{ item }">
            <span v-if="item.isactive">
              <v-icon  class="mr-2  v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon  class="mr-2  v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template> -->

    <template v-slot:item.action="{ item }">
     <div>
        <v-avatar style="" size="25" class="edit-avatar">
          <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
       </v-avatar>
      </div>
      <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
    </template>
    <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
  </v-data-table>

  <v-dialog v-model="import_dialog" max-width="500px">
  <v-card>
    <v-card-title>
      <span class="headline mb-5">Import Caste</span>
       <v-spacer></v-spacer>
       <v-btn small color="success" @click="generateExcel" class="mb-5">
      Download Excel Template
    </v-btn>
    </v-card-title>

    <v-card-text>
      <v-file-input
        v-model="file"
        label="Select Caste CSV File"
        prepend-icon="mdi-file"
        outlined
        rounded
        dense
        show-size
      ></v-file-input>
    </v-card-text>

    <v-card-actions class="justify-center">
      <v-btn color="blue darken-1" text @click="import_dialog = false">Cancel</v-btn>
      <v-btn color="primary darken-1" @click="importCast" :disabled="!file">Submit</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
   <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</div>
</template>

<script>
import axios from 'axios'
import * as XLSX from 'xlsx'
  export default {
    data: () => ({
      valid: false,
      overlay:false,
    errorMsg: {
      castId: false
    },
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search:'',
      file:null,
      import_dialog:false,
      dialog: false,
      headers: [
        {
          text: 'Cast',
          align: 'left',
          sortable: false,
          value: 'cast_super_master',
        },
        {
          text: 'Cast In Unicode',
          align: 'left',
          sortable: false,
          value: 'unicode_cast_name',
        },
        // {
        //   text: 'Active',align: 'left',sortable: true,value: 'isactive',
        // },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      cast_super_master_list: [],
      editedIndex: -1,
      editedItem: {
        castId: '',
        cast_super_master: '',
        unicode_cast_name:""
        //isactive:true  
      },
      defaultItem: {
        castId: '',
        cast_super_master: '',
        unicode_cast_name:""
        //isactive:true      
      },
      fieldNames: ["Caste Name", "Caste In Unicode"]
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Cast' : 'Edit Cast'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      overlay (val) {
        val = () => {
          this.overlay = false
        };
      },
    },

    // created () {
    //   this.initialize()
    // },
    mounted(){
      this.onLoad()       
     },
    methods: {
      openFileSelector() {
       this.import_dialog = true;
      },

      importCast() {

        if (!this.file) {
          this.showSnackbar("#b71c1c", "Please select a file!");
          return;
        }

        const formData = new FormData();
        formData.append("file", this.file);

        this.overlay = true;

        axios.post("/Admin/importCast", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "EPS-token": localStorage.getItem("EPS-token"),
            "EPS-uid": localStorage.getItem("EPS-uid"),
            "router-path": this.$route.path
          }
        })
        .then((res) => {

          if (res.data.status === "SUCCESS") {
            this.showSnackbar("#4caf50", res.data.snackbar);
            this.onLoad();
          } else {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            this.onLoad();
          }

          this.import_dialog = false;
          this.file = null;

        })
        .catch((error) => {
          console.error("Import failed:", error);
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {
          this.overlay = false;
        });
      },

     generateExcel() {
        try {
          const dataForSheet = [this.fieldNames];
          const worksheet = XLSX.utils.aoa_to_sheet(dataForSheet);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Bulk Import Cast");
          const wscols = this.fieldNames.map(() => ({ wch: 20 }));
          worksheet['!cols'] = wscols;
          XLSX.writeFile(workbook, "Cast_Import_Template.xlsx");
          
        } catch (error) {
          console.error("Error generating Excel:", error);
          alert("Failed to generate Excel file.");
        }
      },

      initializeErrorMsgFalse() {
        this.errorMsg.castId = false;
      },

    onLoad(){
      this.overlay=true;
          axios
      .post("/Admin/adminCast")
      .then(res => {
        if (res.data.msg == "200") {
          if(this.load = true){
            this.overlay=false;
            this.cast_super_master_list = res.data.cast_super_master_list;
          }
        } else {
        }
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log(error);
      })
      .finally(()=>{ 
        var overlay=false;
      });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem (item) {
        this.editedIndex = this.cast_super_master_list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
    },

      // deleteItem (item) {
      //   const index = this.language_super_master_list.indexOf(item)
      //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
      // },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save() {
        if (this.editedIndex > -1) {
          if (this.isValidated()) {
            axios
              .post("/Admin/editAdminCast", this.editedItem)
              .then(res => {
                if (res.data.status.code == "SUCCESS") {
                  Object.assign(
                    this.cast_super_master_list[this.editedIndex],
                    this.editedItem
                  );
                  this.showSnackbar(
                    "#4caf50",
                    "Cast Details Updated Successfully..."
                  ); // show snackbar on success
                }
                else if (res.data.status.code == "NA") {
                  this.showSnackbar("#b71c1c", "Cast Already Present!!!"); // show snackbar on error
                }
              })
              .catch(error => {
                window.console.log(error);
              });

            this.close();
          }
        } else {
            axios
              .post("/Admin/saveAdminCast", this.editedItem)
              .then(res => {
                if (res.data.status.code == "SUCCESS") {
                  this.cast_super_master_list.push(this.editedItem);
                  this.showSnackbar("#4caf50", "Cast Added Successfully..."); // show snackbar on success
                  this.onLoad()
                } else if (res.data.status.code == "NA") {
                  this.showSnackbar("#b71c1c", "Cast Already Present!!!"); // show snackbar on error
                }
              })
              .catch(error => {
                window.console.log(error);
              });

            this.close(); 
        }
      }, // end of save()

      isValidated() {
        if (this.editedItem.castId) {
          return true;
        } else {
          if (!this.editedItem.castId) {
            this.errorMsg.castId = true;
          }

          return false;
        }
      } // .....end of isValidated()
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
</style>